import { render, staticRenderFns } from "./GenerateJigFeedbackModal.vue?vue&type=template&id=4f4d6138"
import script from "./GenerateJigFeedbackModal.vue?vue&type=script&lang=ts"
export * from "./GenerateJigFeedbackModal.vue?vue&type=script&lang=ts"
import style0 from "./GenerateJigFeedbackModal.vue?vue&type=style&index=0&id=4f4d6138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports